export const bridgeUserErrorStates = [
  1010, // needs_manual_refresh
  429, // needs_human_action
  402, // login_failed,
];
